import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { formatDecimals, formatLocal } from 'utils'
import { IconCell } from 'styles/styled-components'
import { CNR, CNS, TOKEN } from 'constants/tokens'
import { AddressLink, TruncateAddress, TruncateTxn } from 'components/Utils'
import ShowIcon from 'components/Images/icons/Icons'

const ConversionTxnsTableColumns = [
  {
    title: 'Txn Hash',
    dataIndex: 'txid',
    render: (txid) => (
      <Link to={`/transaction/${txid}`}>
        <TruncateTxn address>{txid}</TruncateTxn>
      </Link>
    ),
    width: 180,
  },
  {
    title: 'Age',
    dataIndex: 'date',
    render: (timestamp) => moment(timestamp).fromNow(),
    width: 140,
  },
  {
    title: 'Address',
    dataIndex: 'address',
    render: (address) => (
      <AddressLink address={address}>
        <TruncateAddress address>{address}</TruncateAddress>
      </AddressLink>
    ),
    width: 180,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (confirmed) => (confirmed ? <span>SUCCESS</span> : <span>FAILED</span>),
  },
  {
    title: 'Convert',
    dataIndex: 'convertAmount',
    render: (quant, record) => {
      const token = record.token === TOKEN.CNS ? CNS : CNR
      return (
        <IconCell>
          <Link to={`/tokens/${token.shortName.toLowerCase()}`}>
            <ShowIcon icon={token.shortName.toLowerCase()} width="20px" />
          </Link>
          <span>
            {formatLocal(formatDecimals(quant, 8), 2)}&nbsp;
            <Link to={`/tokens/${token.shortName.toLowerCase()}`}>{token.symbol}</Link>
          </span>
        </IconCell>
      )
    },
  },
  {
    title: 'Receive',
    dataIndex: 'receiveAmount',
    render: (quant, record) => {
      const token = record.token === TOKEN.CNS ? CNR : CNS
      return (
        <IconCell className="Table__cell--hasIcon">
          <Link to={`/tokens/${token.shortName.toLowerCase()}`}>
            <ShowIcon icon={token.shortName.toLowerCase()} width="20px" />
          </Link>
          <span>
            {formatLocal(formatDecimals(quant, 8), 2)}&nbsp;
            <Link to={`/tokens/${token.shortName.toLowerCase()}`}>{token.symbol}</Link>
          </span>
        </IconCell>
      )
    },
  },
]

export default ConversionTxnsTableColumns
